import { ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import BaseEntitiesSearchAutocomplete, {
  BaseEntitiesSearchAutocompleteInheritableProps,
} from "@/common/components/Entity/components/BaseEntitiesSearchAutocomplete";
import AppIcon from "@/common/components/Icons/AppIcon";
import { renderIf } from "@/common/helpers/render/renderIf";
import { AutocompleteOptionType } from "@/common/ts/autocomplete";
import { apiClient } from "@/core/api/ApiClient";
import { DepartmentDto, DepartmentGetPaginatedDto } from "@/core/api/generated/v1";

import { departmentToOption } from "./DepartmentAutocomplete";

export interface DepartmentsAutocompleteProps extends BaseEntitiesSearchAutocompleteInheritableProps<DepartmentDto> {
  searchFilters?: Partial<Omit<DepartmentGetPaginatedDto, "search" | "includeIds">>;
}

export default function DepartmentsAutocomplete({
  searchFilters,

  isPreload = true,
  ...otherProps
}: DepartmentsAutocompleteProps) {
  return (
    <BaseEntitiesSearchAutocomplete
      sx={{ minWidth: 200, flex: 1 }}
      entityToOption={departmentToOption}
      isPreload={isPreload}
      request={{
        requestFunc: apiClient.departmentsApi.apiV1DepartmentsGetPost,
        limit: 25,
        parameters: {
          nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
          departmentGetPaginatedDto: {
            ...searchFilters,
          },
        },
        combineParameters: (params, newParams) => ({
          ...params,
          departmentGetPaginatedDto: {
            ...params.departmentGetPaginatedDto,
            ...newParams,
          },
        }),
        deps: [],
      }}
      label='Departments'
      placeholder='Search for departments...'
      renderOption={(props, option) => {
        return (
          <ListItem {...props}>
            <ListItemIcon>
              {renderIf()
                .if(option.optionType === AutocompleteOptionType.Normal)
                .then(<AppIcon of='department' />)
                .elseif(option.optionType === AutocompleteOptionType.DynamicCreateNew)
                .then(<AppIcon of='add' />)
                .render()}
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <Typography
                    variant={
                      option.optionType === AutocompleteOptionType.DynamicCreateNew
                        ? "subtitle1"
                        : "body1"
                    }
                    component='div'
                  >
                    {option.title}
                  </Typography>
                  {option.data && (
                    <Typography component='div' variant='body2'>
                      {option.data?.description}
                    </Typography>
                  )}
                </>
              }
            />
          </ListItem>
        );
      }}
      {...otherProps}
    />
  );
}
